import { AUDIT_LIST_QUERY_STATUS } from "../constants/audit-list-query-status.js";
import { AUDIT_STATUS } from "../constants/audit-status.js";
import { auditSaleReopenService } from "../services/auditSaleReopenService.js";
import { canViewSpecialApprovalAudits } from "./can-view-special-approval-audits.js";
import { filterVisibleAuditGroupsByPermission } from "./filter-visible-audit-groups-by-permission.js";
import { getViewerRoleCodesFromLocalStorage } from "./get-viewer-role-codes-from-local-storage.js";
import { getViewerRolesFromLocalStorage } from "./get-viewer-roles-from-local-storage.js";

/**
 * Conta grupos de auditoria pendentes visíveis para o usuário.
 * Usa `GET /audit/sale-reopen?status=pendente` (não há endpoint de count dedicado).
 * Uma página (pageSize 100) basta para o indicador da sidebar.
 *
 * @returns {Promise<number>}
 */
export async function fetchPendingAuditSaleReopenCount() {
  const response = await auditSaleReopenService.getAuditSaleReopenList({
    page: 1,
    pageSize: 100,
    status: AUDIT_LIST_QUERY_STATUS.tabToApiValue[AUDIT_STATUS.PENDING],
  });

  if (!response?.success) {
    return 0;
  }

  const payload = response?.data || {};
  const groups = Array.isArray(payload?.groups) ? payload.groups : [];
  if (groups.length === 0) {
    return 0;
  }

  const viewerRoles = getViewerRolesFromLocalStorage();
  const viewerRoleCodes = getViewerRoleCodesFromLocalStorage();
  const canViewSpecial = canViewSpecialApprovalAudits(
    payload,
    viewerRoleCodes,
    viewerRoles,
  );
  const visible = filterVisibleAuditGroupsByPermission(groups, canViewSpecial);

  return visible.length;
}
